if ($('#section-video').length) {
    var videoInit_flag = true;

    function videoInit() {
        var vidDefer = document.getElementsByTagName('iframe');
        for (var i=0; i<vidDefer.length; i++) {
            if(vidDefer[i].getAttribute('data-src') && vidDefer[i].getAttribute('data-privacy-src')) {
                vidDefer[i].setAttribute('src', (
                    consense_experience ?
                        vidDefer[i].getAttribute('data-privacy-src') :
                        vidDefer[i].getAttribute('data-src')
                ) );
            } else if (vidDefer[i].getAttribute('data-src')) {
                vidDefer[i].setAttribute('src', vidDefer[i].getAttribute('data-src'));
            }
        }
    }

    var videoOffset= $('#section-video').offset().top;
    function onScrollForVideo(e) {
        // console.log((parseInt(window.pageYOffset) + parseInt(window.innerHeight)), parseInt(videoOffset));
        if (videoInit_flag && (parseInt(window.pageYOffset) + parseInt(window.innerHeight)) > (parseInt(videoOffset) - 500)) {
            videoInit_flag = false;
            videoInit();
            document.removeEventListener("scroll", onScrollForVideo)
        }
    }
    document.addEventListener("scroll", onScrollForVideo);
}